import {QueuedCommandService} from "../../services/QueuedCommandService";
import {NotificationService} from "../../services/NotificationService";
import {QueuedCommand} from "../../entities/QueuedCommand";
import {PagingModel} from "../paging/PagingModel";

export class CmdCenterQueuedCmdModel extends PagingModel<QueuedCommand> {
    static $inject = ['$q','QueuedCommandService','NotificationService'];
    errorMessage:string = "";
    //addedAssets:Asset[] = [];
    //selectedAddedAssets:Asset[] = [];
    searchText:string = "";
    before:string = "";
    constructor($q:ng.IQService,
                public pagingService:QueuedCommandService,
                public notifyService:NotificationService) {
        super($q, pagingService, notifyService);
    }
    init(){

    }
    entityName():string{
        return "queuedcommand";
    }
    displayName():string{
        return "Queued Commands";
    }
    transformItem(entity:QueuedCommand){
    }
    getColumnDefs():ng.IPromise<void>{
        this.nameValuePairs =
            [
                ['created', 'Created', 200],
                ['commandType', 'Command Type', 150],
                ['commandText', 'Command Text', 310],
                ['status', 'Status', 135],
                ['lastAttempt', 'Last Attempt', 215],
                ['vTagID', 'V-Tag ID', 120],
                ['retryCount', 'Retry Count', 150],
                ['reason', 'Reason', 145],
                ['amsName', 'Run With AMS', 140],
            ];
        return this.$q.when();
    }
    getPagedPromise():ng.IPromise<any>{
        return this.pagingService.getPagedByTypeStatus(this.selectedCommandType,this.selectedCommandStatus,this.search,this.before,this.page,this.pageSize,this.orderColumn,this.orderDirection);
    }
    getCountPromise():ng.IPromise<any>{
        return this.pagingService.getCountByTypeStatus(this.selectedCommandType,this.selectedCommandStatus,this.search,this.before);
    }
    cancelCommands():ng.IPromise<void>{
        var selected:QueuedCommand[] = this.selectedItems.slice(0);
        var updateStatusPromises:ng.IPromise<any>[] = [];
        $.each(selected,(i,val)=>{
            updateStatusPromises.push(this.pagingService.updateStatus(val.id, "Failed", "Cancelled by user"));
        });
        return this.$q.all(updateStatusPromises).then((data)=>{
            this.notifyService.notify("Command(s) cancelled successfully.");
            return this.$q.when();
        })
        .catch((exc)=>{
            this.notifyService.notifyError("Error in cancelling commands:",exc);
            return this.$q.when();
        });
    }
    resendCommands(){
        var selected:QueuedCommand[] = this.selectedItems.slice(0);
        var toUpdate:QueuedCommand[] = [];
        var toInsert:QueuedCommand[] = [];
        $.each(selected,(i,val)=>{
            var newQC = new QueuedCommand();
            newQC.parseJson(val);
            newQC.id = null;
            newQC.status = "Queued";
            newQC.retryCount = "0";
            newQC.lastAttempt = null;
            newQC.reason = null;
            newQC.created = null;
            toInsert.push(newQC);
            if(val.status == "Failed"){
                val.status = "Resent";
                var upQC = new QueuedCommand();
                upQC.parseJson(val);
                toUpdate.push(upQC);
            }
        });
        return this.pagingService.inserts(toInsert).then(()=>{
            return this.pagingService.updates(toUpdate);
        });
    }
    commandTypes:string[] = ["","Get Position","Set Position","Get Threshold","Set Threshold","Set Security","Fixed Relay","Accel Sensor","Shutdown","Resume","Set Algorithm","Set Box","Set Dwell Time"];
    selectedCommandType:string = "";
    commandStatuses:string[] = ["","Queued","In Progress","Success","Failed"];
    selectedCommandStatus:string = "";
}
